module.exports = __webpack_public_path__ + "img/Icon awesome-facebook-messenger.247e6351.svg";